/**
 * TRAVEL-step distance label (Plan 28 §E/SD2 — "entered track" relabel).
 *
 * `MicroStep.travelDistanceFeet` is the ENTERED track's full declared
 * length (`AStarMicroStepExpander` emits `toNode.lengthFeet`), not the
 * leg's real path distance — the label says so instead of letting a bare
 * number read as drive distance. Value and totals unchanged;
 * `actualPathFeet` (real leg distance) stays deferred to the post-demo
 * backlog.
 */
export const formatEnteredTrackFeet = (feet: number): string =>
  `entered track: ${feet.toLocaleString('en-US')} ft`
